<template>
  <v-container fluid>
    <v-card>
      <v-card-title class="headline mb-0">為替レート検索</v-card-title>
      <v-card-actions>
        <v-btn
          @click="search"
          class="btn-search"
          v-permit.SHARP_ER_SEARCH
        >{{$t('app.buttons.search')}}</v-btn>
        <v-btn to="/m0101/new" v-permit.SHARP_ER_NEW>{{$t('app.buttons.new')}}</v-btn>
        <v-btn
          :disabled="selected.length!==1"
          @click="edit"
          v-permit.SHARP_ER_EDIT.SHARP_ER_DETAIL
        >{{$t('app.buttons.edit')}}</v-btn>
        <v-btn
          :disabled="selected.length===0"
          @click="remove"
          v-permit.SHARP_ER_DELETE
        >{{$t('app.buttons.remove')}}</v-btn>
      </v-card-actions>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 sm6 xs6>
              <remote-autocomplete label="外貨名" url="currencies/kv" v-model="query.currencyCode"/>
            </v-flex>
            <v-flex md3 sm6 xs6>
              <date-picker label="適用開始日" v-model="query.startDate"/>
            </v-flex>
            <v-flex md3 sm6 xs6>
              <date-picker :min="query.startDate" label="適用終了日" v-model="query.endDate"/>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
    <v-card class="mt-2">
      <v-card-title primary-title>
        <h3 class="headline mb-0">為替</h3>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="results"
        :loading="loading"
        :pagination.sync="pagination"
        :rows-per-page-items="[10]"
        :total-items="pagination.totalItems"
        class="elevation-0"
        item-key="id"
        select-all
        v-model="selected"
      >
        <template slot="items" slot-scope="props">
          <td>
            <v-checkbox hide-details primary v-model="props.selected"></v-checkbox>
          </td>
          <!--<td :key="head.text" v-for="head in headers">{{ props.item[head.value] }}</td>-->
          <td>{{ props.item.currencyCode }}</td>
          <td>{{ props.item.rate }}</td>
          <td>{{ props.item.scopeName }}</td>
          <td>{{ props.item.startDate }}</td>
          <td>{{ props.item.endDate }}</td>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      query: {},
      selected: [],
      results: [],
      loading: false,
      pagination: {
        page: 1
      },
      headers: [
        { text: '外貨名', value: 'currency.code', sortable: false },
        { text: 'レート', value: 'rate', sortable: false },
        { text: 'レート区分', value: 'scope', sortable: false },
        { text: '適用開始日', value: 'startDate', sortable: false },
        { text: '適用終了日', value: 'endDate', sortable: false }
      ]
    }
  },
  methods: {
    params() {
      return {
        params: {
          ...this.query,
          ...this.$pageable()
        }
      }
    },
    search() {
      this.pagination.page = 1
      this.load()
    },
    load() {
      this.autoload = true
      this.$storeParams()
      this.loading = true
      this.$http.get('/exchange-rates', this.params()).then(res => {
        this.pagination.page = res.data.number + 1
        this.pagination.rowsPerPage = res.data.size
        this.pagination.totalItems = res.data.totalElements
        this.results = res.data.content
        this.loading = false
        this.selected = []
      })
    },
    edit() {
      this.$router.push({
        name: 'EditM0101',
        query: { id: this.selected[0].id }
      })
    },
    remove() {
      this.$confirm({ content: this.$t('app.messages.removeConfirm') }).then(
        () => {
          Promise.all(
            this.selected.map(s => {
              return this.$http.delete(`/exchange-rates/${s.id}`)
            })
          ).then(() => {
            this.load()
            this.selected = []
          })
          this.$message('', '削除成功')
        }
      )
    }
  },
  mounted() {
    this.$loadParams()
  },
  watch: {
    pagination() {
      if (this.autoload) this.load()
    }
  }
}
</script>
